/* eslint no-console: 0 */

// catch errors
export const catchErr = (err) => {
  console.error('Error catched:', err.message, 'Please refresh.')
}

// converts object to query parameters
export const serialize = (obj) => {
  if (typeof obj !== 'object') { return obj }
  const pairs = []

  // loop throgh the objects
  Object.keys(obj).forEach((key) => {
    if (obj[key]) {
      pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
    }
  })

  return pairs.join('&')
}

export const getListIndexById = (id, list) => {
  for (let i = 0, l = list.size; i < l; i++) {
    if (list.get(i).get('id') === id) {
      return i
    }
  }

  return -1
}

export const getListIndex = (needle, list, term) => {
  for (let i = 0, l = list.size; i < l; i++) {
    if (list.getIn([i, term]) === needle) {
      return i
    }
  }

  return -1
}

export const getGrade = (value, grades) => {
  for (let i = 0, l = grades.size; i < l; i++) {
    if (grades.getIn([i, 'value']) === value) {
      return grades.get(i)
    }
  }

  return false
}

export const computeFg = (mt, ft) => {
  mt = Number(mt)
  ft = Number(ft)

  if (isNaN(mt) || !mt || isNaN(ft) || !ft) {
    return ''
  }

  const ave = (mt + ft) / 2
  const pres = parseFloat(ave.toPrecision(12))
  return (Math.floor(pres * 10) / 10).toFixed(1)
}



// WEBPACK FOOTER //
// ./src/utils/helpers.js